import token from "../AuthToken";
import Config from "../Config";

const getAlternateImageUrl = function(src) {
    return process.env.REACT_APP_PUBLIC_URL + '/get_image/?url='+ src;
}

export default function addDefaultSrc(ev) {
    let imageUrl = getAlternateImageUrl(ev.target.src);
    return fetch(imageUrl, {
        headers: {
            Authorization: 'Token ' + token,
            'Content-Type': 'application/json'
        }
    })
    .then(e => e.status < 300 ? imageUrl : Config.brokenPlayerImage)
    .then(e => ev.target.src = e)
    .catch((e) => {
        console.error("Image cannot be fetch: " + e)
        e.target.src = Config.brokenPlayerImage
    })
}